<template>
<div class="chapter">
<div class="inner_page">
<p class="normala">If you think you can reason with evil, then go ahead and I wish you great success. But talking is not my bag. My specialty is warfare and my goal is destruction. I am going to bust this kingdom of evil if I can live that long. I AM GOING TO DESTROY THE MAFIA.</p>
<p class="right1-2"><span>—Mack Bolan, <i>The Executioner</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// franmatter01.vue?cf215b16